<template>
  <v-multiselect
    :options='stades'
    :value='$store.state.select.value'
    label='nom'
    @input='setActiveStade'
    placeholder="Sélectionner un stade"
  >
    <template slot='noResult'>
      Aucun stade correspondant
    </template>
  </v-multiselect>
</template>

<script>
export default {
  name: 'SelectStade',

  props: {
    idRefCulture: {
      type: Number,
      required: true
    },
    idRefStadeFin: Number
  },

  computed: {
    allStades () {
      return this.$store.getters['referentiel/getStadesByCulture'](
        this.idRefCulture
      )
    },
    ordreFin () {
      return this.idRefStadeFin
        ? this.$store.getters['referentiel/getStadeOrdre'](this.idRefStadeFin)
        : 999
    },
    stades () {
      return this.allStades.filter(stade => stade.ordre < this.ordreFin)
    }
  },

  methods: {
    setActiveStade (stade) {
      this.$store.commit('select/SET_VALUE', stade)
    }
  }
}
</script>
